module.exports = __webpack_public_path__ + "fonts/KohinoorTelugu-Medium.b70ec051.ttf";